import {FORM_ERROR} from 'final-form';
import {MessageDescriptor} from 'react-intl';

import validationRules from 'coreUtils/validationRules';
import {ICustomerAPI, INewsletterProfile} from 'coreClasses/customer/ICustomer';

import {TCustomerApi} from './IAuthLoginForm';
import messages from './messages';

const rules = {
	email: [
		{
			rule: validationRules.isRequired,
			errorMessage: messages.emailNotFound,
		},
		{
			rule: validationRules.validateCustomerName,
			errorMessage: messages.latinCharactersError,
		},
		{
			rule: validationRules.isEmail,
			errorMessage: messages.emailIsInvalid,
		},
	],
	password: [
		{
			rule: validationRules.isRequired,
			errorMessage: messages.passwordNotFound,
		},
	],
};

const verify = (value, validation) => (validation.rule(value) ? null : validation.errorMessage);

const firstErrorFor = (value) => (error, validation) => error || verify(value, validation);

const validate = (values: Record<string, any>): Record<string, MessageDescriptor> => {
	const {email, password} = values;

	const matches = [
		['email', rules.email.reduce(firstErrorFor(email), null)],
		['password', rules.password.reduce(firstErrorFor(password), null)],
	];

	return Object.fromEntries(matches.filter((match) => !!match[1]));
};

export const schema = {rules, validate};

const createFlowError = (error: Error, message: MessageDescriptor) => ({
	[FORM_ERROR]: {error, message},
});

export const createLoginFlow = (api: TCustomerApi) => async (values) => {
	const {email, password} = values;
	let customer: ICustomerAPI, newsletter: INewsletterProfile;

	try {
		customer = await api.loginCustomer({email, password});
	} catch (error) {
		return createFlowError(error, messages.matchNotFound);
	}

	try {
		newsletter = await api.getNewsletterProfile(email);

		// This call covers misalignment between SFCC and Emarsys
		// https://thelevelgroup.atlassian.net/browse/THP-1411
		if (customer.c_newsletter !== newsletter.isSubscribed) {
			await api.updateCustomer({acceptsMarketing: newsletter.isSubscribed});
		}
	} catch (error) {
		return createFlowError(error, messages.unexpectedError);
	}

	return;
};
